module.exports = __webpack_public_path__ + "assets/img/jtfx56.9a020ccf.jpg";